import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authService } from '@/services';

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const isAuthenticated = computed(() => !!user.value);

  async function login(username, password) {
    loading.value = true;
    error.value = null;
    try {
      const data = await authService.login(username, password);
      user.value = data.user;
      return data;
    } catch (err) {
      error.value = err.message;
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function logout() {
    loading.value = true;
    try {
      await authService.logout();
    } finally {
      user.value = null;
      loading.value = false;
    }
  }

  async function fetchCurrentUser() {
    loading.value = true;
    try {
      const data = await authService.getCurrentUser();
      user.value = data;
      return data;
    } catch (err) {
      user.value = null;
      throw err;
    } finally {
      loading.value = false;
    }
  }

  function initializeAuth() {
    const storedUser = authService.getUser();
    if (storedUser) {
      user.value = storedUser;
    }
  }

  return {
    user,
    loading,
    error,
    isAuthenticated,
    login,
    logout,
    fetchCurrentUser,
    initializeAuth
  };
});
